<template>
  <div v-show="currAudio" class="audio-control w100 pof zi100"
       :class="[{unlock, 'show-all-time': noShowLock},isShow ? 'show-control' : 'hide-control']"
       @mouseover.self="changeControl" @mouseleave="hideControl('leave')">
    <template v-if="currAudio">
      <zcl-player v-if="isZcl"
                  class="pof bsb h0 b0 ovh"
                  @load="audioLoad"
                  @update="audioUpdate"
                  @stop="audioEnd"
                  @play="audioPlay"
                  @pause="audioPause"
                  ref="audioInner"
                  api="webAudioPlayer"
                  path="webPlayer"
                  :content_id="resourceInfo.content_id"
                  :datafile_id="resourceInfo.datafile_id"
                  :sku_id="resourceInfo.sku_id"></zcl-player>
      <audio :src="resourceInfo.cn_url" :autoplay="isAutoPlay" @play="audioPlay" @pause="audioPause" @timeupdate="audioUpdate"
             @durationchange="durationchange" @ended="audioEnd" @loadeddata="audioLoad"
             ref="audioInner" v-else></audio>
      <div class="control-inner mlr-auto h100 bsb flex aic jcb"
           :class="{playing, mute, collection: resourceInfo.is_collection}">
        <div class="ctrl flex aic jcc csp h100 por" v-for="(ctrl, i) in ctrls" :key="i" :class="ctrl + '-box'" @mouseover.stop="showModal($event,ctrl)" @mouseleave.stop="hideModal($event,ctrl)">
          <div class="ctrl-inner w100" :class="{h100: ctrl === 'progress'}">
            <div v-if="maskIcon.includes(ctrl)" :class="['audio-ico', ctrl]" @click="ctrlCb(ctrl)"></div>
            <div v-else-if="ctrl === 'speed'">
              <span>倍数</span>
            </div>
            <div class="audio-icon-img ovh" v-else-if="ctrl === 'icon'"
                 @click="changeAudioPage">
              <img :src="courseInfo.bgimg" alt="" class="w100 h100 vam">
            </div>
            <div class="progress flex-col jce h100" v-else-if="ctrl === 'progress'">
              <span class="title">{{resourceInfo.name}}</span>
              <div class="flex aic">
                <df-progress @change="changeTime" class="flex-1" v-model="timeValue"></df-progress>
                <span class="time">{{currTime}} / {{duration}}</span>
              </div>
            </div>
          </div>
          <div class="modal poa t0" v-if="modalCtrl.includes(ctrl)" :class="(isModal && ctrl === 'list') || (isSound && ctrl === 'sound') ? 'modal-show' : 'modal-hide'">
            <div class="speed-modal tac" v-if="ctrl === 'speed'">
              <div class="speed-modal-inner">
                <div class="speed-item csp" :class="{active: sT === +currSpeed}" v-for="(sT, j) in speedType" :key="j"
                     @click="setSpeed(sT)">{{sT +
                  'X'}}
                </div>
              </div>
            </div>
            <div class="sound-modal tac" v-else-if="ctrl === 'sound'">
              <div class="sound-modal-inner flex-col aic">
                <div class="sound-value">{{soundValue}}%</div>
                <df-progress @move="soundProgressMove" v-model="soundValue" vertical @change="soundChange"
                             class="flex-1"></df-progress>
              </div>
            </div>
            <div class="list-modal ovh" v-else-if="ctrl === 'list'">
              <div class="list-modal-inner flex-col">
                <div class="course-title">{{courseInfo.name | filterTitle}}
                  <span class="pl10">({{total}}个课时)</span>
                </div>
                <div class="resource-list ova">
                  <play-list ref="playList" :curr="curr" :limits="limits" :total="total" :get-data="getResourceList">
                    <template #default="{row, index}">
                      <div class="resource flex aic" :class="{active: rid === row.id}" @click="getResource(row.id,1)">
                        <i class="audio-ico" :class="canPlayType(row)"></i>
                        <span class="resource-name">{{row.name}}</span>
                      </div>
                    </template>
                  </play-list>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="lock-bg audio-ico img poa t0 jcc lh1" v-show="!noShowLock" @mouseover="changeControl">
        <i class="audio-ico lock lh1 abs-mc csp" @click="unlock = !unlock"></i>
      </div>
    </template>
  </div>
</template>

<script>
  import {mapGetters, mapMutations} from 'vuex'

  export default {
    name: "AudioControl",
    filters: {
      filterTitle(text) {
        text = text ? text.split(/[:：]/) : '';
        return text[1] || text[0];
      }
    },
    computed: {
      ...mapGetters(['userInfo', 'currAudio', 'isShowPayPopup']),
      audioInner() {
        return this.currAudio ? this.$refs.audioInner[0] || this.$refs.audioInner : null;
      },
      playList() {
        let vm = this.$refs.playList;
        return vm[0] || vm;
      },
      isZcl() {
        return this.resourceInfo.content_id && this.resourceInfo.datafile_id && this.resourceInfo.sku_id;
      },
      ctrls() {
        let control = this.control;
        let df = [
          'icon',
          'prev',
          'play',
          'next',
          'progress',
          'speed',
          'collect',
          'sound',
          'list',
        ];
        if (typeof control === 'function') {
          control = control(df);
        } else if (control === undefined) {
          control = df;
        }
        control += '';
        return control.split(',').map(s => s.trim());
      },
      mute() {
        return +this.soundValue === 0;
      },
    },
    props: {
      control: String | Function | Array,
      isLock: {
        type: Boolean,
        default: true,
      },
      noShowLock: {
        type: Boolean,
        default: false,
      },
    },
    watch: {
      isLock(bool) {
        this.unlock = !bool;
      },
      currAudio(val) {
        this.initAudio();
      },
    },
    data() {
      return {
        //
        maskIcon: [
          'prev',
          'play',
          'next',
          'collect',
          'sound',
          'list',
        ],
        modalCtrl: [
          'speed',
          'sound',
          'list',
        ],

        speedType: [2, 1.5, 1.25, 1, 0.75],

        unlock: true,
        playing: false,

        soundValue: 100,
        timeValue: 0,
        totalTime: 0,
        playbackTime: 0,
        currSpeed: 1,
        duration: '00:00',
        currTime: '00:00',
        courseInfo: {},
        resourceInfo: {},

        curr: 1,
        limits: 30,
        total: 0,

        cid: '',
        rid: '',

        isShow: true,
        timer: null,
        isModal: false,
        modalTimer: null,
        isAutoPlay: true,
				isSound:false,
				soundTimer:null,
				preventReClick:false //双重点击
      };
    },
    created() {
      this.initAudio();
      this.unlock = !this.isLock;
			
    },
    mounted() {
    },
    methods: {
      ...mapMutations(['setCurrAudio']),
      initAudio() {
        if (!this.currAudio) return;
				this.keyDownMethobs();
        let {cid, rid} = this;
        this.cid = this.currAudio.cid;
        this.rid = this.currAudio.rid;
        cid !== this.cid && this.cid && this.getResourceList(this.curr, this.limits);
        rid !== this.rid && this.rid && this.getResource();
      },
		  keyDownMethobs(){
				//音频添加上下左右空格快捷键
				let that = this;
				document.onkeydown = function(e) {   //全屏并按下空格暂停
					e = e || window.event;
					let key = e.keyCode || e.charCode;  
					if(key===32||key === 37||key === 38||key === 39||key === 40){
						// 阻止默认空格事件
						that.changeControl();
						if(e.preventDefault){
								e.preventDefault();
						}else{
								e.returnValue = false;
						}
					}
					//事件中keycode=32为空格事件
					if (key === 32) {
						
						that.ctrlCb('play')
					}
					if (key === 37 ) {
						// left
						let currentTime = that.audioInner.currentTime
						that.audioInner.currentTime = ((currentTime - 3) > 0) ? currentTime - 3 : 0;
						// 更新时间 不可小于0
						that.audioUpdate()
					}
					if (key === 38 ) {
						// up
						that.showSound();
						let soundVal = that.soundValue;
						that.soundValue = ((soundVal + 5) < 100)? soundVal + 5 : 100;
						that.soundChange(that.soundValue);
					}
					if (key === 39 ) {
						// right
						let currentTime = that.audioInner.currentTime
						that.audioInner.currentTime = currentTime + 3
						// 更新时间
						that.audioUpdate()
					}
					if (key === 40 ) {
						// down
						that.showSound();
						let soundVal = that.soundValue;
						that.soundValue = ((soundVal - 5) > 0)? soundVal - 5 : 0;
						that.soundChange(that.soundValue);
					}
				};
			},
     async changeAudioPage(){
        let url = `/home/audio/details/${this.currAudio.cid}/${this.currAudio.type}`;
        if(this.playing){
          await this.ctrlCb('play');
          setTimeout(() => {
            this.OpenRouter(url);
          }, 300);
        }else{
          this.OpenRouter(url);
        }
      },
      canPlayType(row) {
        let can = row.is_free === 2 || (row.is_free === 1 && this.userInfo.is_web_vip && this.courseInfo.type === 2 ) || (this.courseInfo.is_pay === 1);
        return can ? 'inner-play' : 'inner-lock';
      },
      soundProgressMove(val) {
        this.soundValue = +val.toFixed(0);
      },
      async getResourceList(curr, limits) {
        let res = await this.http.getResourceList({
          course_id: this.cid,
          uid: this.userInfo.uid,
          ...this.Product,
          is_new: 1,
          channel_type: 2,
          curr,
          limits,
          is_web: 1
        });
        this.total = res.resource_list.total;
        this.courseInfo = res;
        this.$emit('get-course-success', res);
        return [...res.resource_list.data];
      },
      async getResource(id = this.rid, isAuto) {
				if(this.preventReClick){
					return
				}
				this.preventReClick = true;
			  setTimeout(()=>{
					this.preventReClick = false;
				},500)
        try {
          this.resourceInfo = await this.http.getResource({
            resources_id: id,
            resources_name: '',
            uid: this.userInfo.uid,
            ...this.Product,
            is_new: 1,
            is_web: 1
          });
          this.rid = id;
          if (this.currAudio && this.currAudio.rid === this.rid && this.currAudio.time) {
            this.currTime = this.Tools.numberToTime(this.currAudio.time * 1000, 'mm:ss');
            this.setCurrAudio(Object.assign(this.currAudio, {rid: id, cid: this.cid, time: this.currAudio.time}));
          } else {
            this.setCurrAudio(Object.assign(this.currAudio, {rid: id, cid: this.cid, time: 0}));
          }
          !!isAuto && (this.isAutoPlay = true);
          this.$emit('get-resource-success', this.resourceInfo);
        } catch (e) {
          if (+e.code === 10020) {
            if (this.isShowPayPopup) {
              return;
            }
            if (+this.courseInfo.type === 2) {
              this.ShowGift({type: 'open-vip'});
            } else if (+this.courseInfo.type === 3) {
              this.ShowGift({type: 'pay', cid: this.cid});
            }
          } else {
            this.ShowToast(e.msg || '网络错误！');
          }
        }
      },
      collectionCourse() {
        if (this.userInfo.uid) {
          this.http.saveCourseCollection({
            uid: this.userInfo.uid,
            course_id: this.cid,
            ...this.Product
          }).then(res => {
            this.ShowToast(res.status === 1 ? '收藏成功' : '取消收藏');
            this.resourceInfo.is_collection = res.status === 1 ? 1 : 0;
            this.$emit('save-success', this.resourceInfo.is_collection);
          }).catch(err => {
            console.log(err);
            this.ShowToast(err.msg || '网络错误！');
          });
        } else {
          this.ShowToast('需要登录后才可以收藏！');
        }
      },


      ///// 控制音频播放
      changeTime(val) {
        this.audioInner.currentTime = Math.round(val * this.totalTime / 100);
      },
      soundChange(val) {
        this.audioInner.volume = (val / 100);
      },
      ctrlCb(type) {
        switch (type) {
          case 'play':
            if (this.playing) {
              this.audioInner.pause();
            } else {
              this.audioInner.play();
            }
            break;
          case 'prev':
            // let prev = '';
            // this.playList.innerArr.find(e => {
            //   if (e.id === this.rid) {
            //     return true;
            //   }
            //   prev = e.id;
            // });
            // prev && this.getResource(prev);
            this.resourceInfo.before_resource_id && this.getResource(this.resourceInfo.before_resource_id);
            // this.resourceInfo.next_resource_id && this.getResource(this.resourceInfo.next_resource_id);
            break;
          case 'next':
            this.resourceInfo.next_resource_id && this.getResource(this.resourceInfo.next_resource_id);
            break;
          case 'collect':
            this.collectionCourse();
            break;
          case 'sound':
            this.soundValue = +!this.soundValue * 100;
            this.soundChange(this.soundValue);
            break;
        }
        this.$emit('control-' + type, this.audioInner);
      },

      ///////// 音频事件
      // 开始播放
      audioPlay() {
        this.playing = true;
        this.isShow = true;
        if (this.isShow) {
          this.hideControl();
        }
        this.$emit('play', this.audioInner);
      },
      // 暂停
      audioPause() {
        this.playing = false;
        this.$emit('pause', this.audioInner);

        if (this.userInfo.uid) {
          this.addPlayback();
        }
      },
      // 播放结束
      audioEnd() {
        this.$emit('end', this.audioInner);

        if (this.userInfo.uid) {
          this.addPlayback();
        }
        this.ctrlCb('next');
      },
      // 获取播放时长
      audioUpdate() {
        this.$emit('update', this.audioInner);
        this.playbackTime = Math.ceil(this.audioInner.currentTime);
        this.currTime = this.Tools.numberToTime(this.audioInner.currentTime * 1000, 'mm:ss');
        this.timeValue = Math.round(this.audioInner.currentTime / this.totalTime * 100);
        this.setCurrAudio(Object.assign(this.currAudio, {rid: this.rid, cid: this.cid, time: this.playbackTime}));
      },
      durationchange() {
        this.$emit('duration-change', this.audioInner);

        let duration = this.isZcl ? this.resourceInfo.total || 0 : this.audioInner.duration;

        this.totalTime = Math.ceil(duration);
        this.duration = this.Tools.numberToTime(duration * 1000, 'mm:ss');
      },
      setSpeed(val = this.currSpeed) {
        this.currSpeed = val;
        this.audioInner.playbackRate = +val || 1;
      },
      // 已加载音频，获取数据
      audioLoad() {
        this.setSpeed();
        if (this.userInfo.uid) {
          this.addRecord();
          this.addCourseRecord();
          this.addPlayTimes();
        }
        let time = this.currAudio;
        time && time.time && (this.audioInner.currentTime = time.time);
        this.$emit('load', this.audioInner);
        if (this.isZcl) {
          this.durationchange();
        } else {
          this.isAutoPlay && this.audioInner.play(); // 部分手机设备不支持自动播放,采取调用play()来达到自动播放效果
        }
      },

      //////// 保存播放状态
      // 添加课时播放时长
      addPlayback() {
        let params = {
          is_web: '',
          uid: this.userInfo.uid,
          resource_id: this.rid,
          total_time: this.totalTime | 0,
          playback_time: this.playbackTime | 0
        };
        this.http.addResourceTime(params).then(res => {
          this.$emit('add-playback', params);
        }).catch(console.log);
      },
      // 添加播放时长记录
      addPlayTimes() {
        let params = {
          uid: this.userInfo.uid,
          resources_id: this.rid,
          times: this.totalTime | 0,
          ...this.Product,
        };
        this.http.addPlayTimes(params).then(res => {
          this.$emit('add-playtime', params);
        }).catch(console.log);
      },
      // 添加观看记录
      addRecord() {
        let params = {
          uid: this.userInfo.uid,
          resource_id: this.rid,
          type: 1,
          ...this.Product,
        };
        this.http.addPlayRecord(params).then(res => {
          this.$emit('add-record', params);
        }).catch(console.log);
      },
      // 添加课程播放记录
      addCourseRecord() {
        let params = {
          course_id: this.cid,
          ...this.Product,
        };
        this.http.addPlayCourse(params).then(res => {
          this.$emit('add-course-record', params);
        }).catch(console.log);
      },
      changeControl() {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.isShow = true;
      },
      // 隐藏工具栏
      hideControl(type) {
        if (!this.unlock) {
          return;
        }
        this.timer = setTimeout(() => {
          this.isShow = false;
        }, 1000)
      },
      showModal(e, prop){
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        if(this.modalTimer){
          clearTimeout(this.modalTimer);
          this.modalTimer = null;
        }
        this.isModal = prop === 'list';
      },
			showSound(){
				clearTimeout(this.soundTimer)
				this.isSound = true;
				this.soundTimer = setTimeout(()=>{
				  this.isSound = false;
				},2000);
			},
      hideModal(e, prop){
        if(prop === 'list'){
          this.modalTimer = setTimeout(()=>{
            this.isModal = false;
          },500);
        }
      }
    }
  }
</script>

<style scoped lang="less">
  @import '../../assets/less/function';

  .unlock {
    .audio-ico {
      &.lock {
        &:after {
          mask-position: -360px -53px;
        }
      }
    }
  }

  .mute {
    .audio-ico {
      &.sound {
        &:after {
          mask-position: -227px -66px;
        }
      }
    }
  }

  .collection {
    .audio-ico {
      &.collect {
        &:after {
          mask-position: -161px -33px;
        }
      }
    }
  }

  .playing {
    .audio-ico {
      &.play {
        &:after {
          mask-position: -93px -69px;
        }
      }
    }
  }

  .audio-ico {
    &.img {
      .spirit(url(../../assets/images/audio_icon.png));
    }
    &:not(.img) {
      .spirit-mask(url(../../assets/images/audio_icon.png));
    }
    &:after {
      width: 32px;
      height: 32px;
      background-color: #fff;
      transition: background-color 0.3s;
    }
    &.prev {
      &:after {
        width: 26px;
        height: 26px;
        mask-position: -2px -60px;
      }
    }
    &.next {
      &:after {
        width: 26px;
        height: 26px;
        mask-position: -29px -60px;
      }
    }
    &.play {
      &:after {
        mask-position: -58px -69px;
      }
    }
    &.collect {
      &:after {
        mask-position: -128px -66px;
      }
    }
    &.sound {
      &:after {
        mask-position: -194px -66px;
      }
    }
    &.list {
      &:after {
        mask-position: -260px -66px;
      }
    }
    &.lock-bg {
      right: 68px;
      transform: translateY(-100%);
      &:after {
        width: 56.6px;
        height: 17px;
        background-position: -298.4px -33px;
      }
    }
    &.lock {
      &:after {
        width: 16px;
        height: 16px;
        mask-position: -360px -34px;
      }
      &:hover {
        &:after {
          background-color: #1177ff;
        }
      }
    }
    &.inner-lock {
      .audio-ico.lock;
    }
    &.inner-play {
      &:after {
        width: 16px;
        height: 16px;
        mask-position: -313px -1px;
      }
    }
  }

  .audio-control {
    // bottom: -50px;
    // bottom: 0;
    height: 50px;
    background-color: rgba(25, 29, 35, 0.95);
    font-size: 14px;
    color: #fff;
    transition: bottom 0.3s;
    &.show-all-time {
      bottom: 0;
    }
    // &.unlock {
    // &:hover {
    //   bottom: 0;
    // }
    // }
    &::before {
      content: '';
      width: 100%;
      height: 17px;
      position: absolute;
      top: -17px;
      left: 0;
    }
  }

  .show-control {
    bottom: 0;
  }

  .hide-control {
    bottom: -50px;
  }

  .control-inner {
    padding: 0 16px;
    width: 1196px;
  }

  .zcl-player {
    + .control-inner {
      .speed-box {
        opacity: 0;
        cursor: unset;
        user-select: none;
        + .model {
          display: none !important;
        }
      }
    }
  }

  .ctrl {
    &:not(:first-child) {
      margin-left: 12px;
    }
    &.speed-box {
      margin: 0 8px 0 49px;
      &:hover {
        color: #1177ff;
      }
    }
    &.list-box {
      &:hover {
        .modal {
          transform: translateY(-100%);
        }
      }
    }

    &:hover {
      .modal {
        transform: translate(-50%, -100%);
        opacity: 1;
      }
      .audio-ico {
        &:not(.img) {
          &:after {
            background-color: #1177ff;
          }
        }
      }
    }
  }

  .progress-box {
    flex: 1;
    .time {
      margin-left: 9px;
      color: rgba(255, 255, 255, 0.7);
      font-size: 12px;
    }
    .title {
      font-size: 12px;
    }
  }

  .audio-icon-img {
    width: 32px;
    height: 32px;
    border-radius: 4px;
  }

  .modal {
    left: 50%;
    padding-bottom: 4px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.6);
    transition: opacity 0.2s 0.3s;
    transform: translate(-50%, 200%);
    opacity: 0;

    > :only-child {
      background-color: rgba(25, 29, 35, 0.9);
      border-radius: 6px;
    }
  }

  .modal-show{
    transform: translateY(-100%);
    opacity: 1;
    
  }
  .modal-hide{
    transition: opacity 0.2s 0.3s;
    opacity: 0;
  }

  .speed-modal-inner {
    width: 80px;
    line-height: 32px;
    .speed-item {
      &:hover,
      &.active {
        font-size: 15px;
        color: #1177ff;
      }
    }
  }

  .sound-modal-inner {
    padding: 8px 0 13px;
    width: 40px;
    height: 88px;
    line-height: 1;
    font-size: 12px;
    .sound-value {
      margin-bottom: 11px;
    }
  }

  .list-box {
    .modal {
      left: unset;
      right: -16px;
      padding-bottom: 0;
      // transform: translateY(200%);
    }
    .list-modal {
      border-radius: 8px 8px 0 0;
    }
  }

  .list-modal-inner {
    width: 550px;
    /*height: 320px;*/
    line-height: 40px;
    color: #fff;
    .course-title {
      padding-left: 24px;
      font-size: 18px;
      line-height: 58px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    }
    .resource {
      padding-left: 32px;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.6);
      .audio-ico {
        margin-right: 7px;
        &.inner-lock {
          &:after {
            background-color: #999fa6;
          }
        }
        &.inner-play {
          &:after {
            background-color: #999fa6;
          }
        }
      }

      &.active {
        color: #1177ff;
      }
      &.active,
      &:hover {
        .audio-ico {
          &:after {
            background-color: #1177ff;
          }
        }
        &:hover {
          background-color: #1f232a;
          .inner-lock {
            &:after {
              mask-position: -313px -1px;
            }
          }
        }
      }
    }
    .resource-list {
      height: 261px;
      max-height: 261px;
      scrollbar-width: none;
    }
  }
</style>